// extracted by mini-css-extract-plugin
export default {"AuthScreen":"AuthScreen_AuthScreen__uagAh","Logo":"AuthScreen_Logo__PnFE+","PageHeading":"AuthScreen_PageHeading__BaPCq"};